import { useEffect, useState } from "react";
import { fetchAudienceIntelligenceResolution } from "../services/audienceIntelligenceService";

export default function useAudienceIntelligenceResolution({
  advertiserId,
  platform,
  campaignId = null,
  campaignName = null,
  startDate = null,
  endDate = null,
}) {
  const scopeKey = JSON.stringify([
    advertiserId == null ? "" : String(advertiserId),
    platform == null ? "" : String(platform),
    campaignId == null ? "" : String(campaignId),
    campaignName == null ? "" : String(campaignName),
    startDate == null ? "" : String(startDate),
    endDate == null ? "" : String(endDate),
  ]);
  const [resolutionState, setResolutionState] = useState({
    scopeKey: "",
    value: null,
  });

  useEffect(() => {
    if (!advertiserId || !platform) {
      setResolutionState({ scopeKey, value: null });
      return undefined;
    }

    const controller = new AbortController();
    let cancelled = false;
    setResolutionState({ scopeKey, value: null });

    fetchAudienceIntelligenceResolution(
      {
        advertiserId,
        platform,
        campaignId,
        campaignName,
        startDate,
        endDate,
      },
      { signal: controller.signal }
    )
      .then((payload) => {
        if (cancelled) return;
        setResolutionState({ scopeKey, value: payload || null });
      })
      .catch((error) => {
        if (controller.signal.aborted || cancelled) return;
        console.warn(
          "[useAudienceIntelligenceResolution] unable to resolve audience intelligence",
          error
        );
        setResolutionState({ scopeKey, value: null });
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [
    advertiserId,
    campaignId,
    campaignName,
    endDate,
    platform,
    scopeKey,
    startDate,
  ]);

  return resolutionState.scopeKey === scopeKey
    ? resolutionState.value
    : null;
}
